import { apiOfferPoster } from '@spo/services/api';
import { useQuery } from '@tanstack/react-query';

export const useOfferPosterExtract = (
  sportId: number | null,
  productNatureId: number | null,
  offerDate: string | undefined,
  launchExtract: boolean,
) => {
  return useQuery({
    queryKey: ['useOfferPosterExtract', sportId, productNatureId],
    queryFn: () => {
      if (offerDate && sportId && productNatureId) {
        return apiOfferPoster.getOfferPosterExtract({
          sportId,
          productNatureId,
          offerDate,
        });
      }
    },
    enabled: !!offerDate && launchExtract,
  });
};
